/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
const BRPrintDocumentFilter = {
  install(Vue) {
    Vue.filter('BRPrintDocumentPFFilter', (documentId) => {
      if (documentId !== undefined) {
        documentId = typeof documentId !== 'string' ? documentId.toString().replace(/[^a-zA-Z ]/g, '') : documentId;
        documentId = documentId.padStart(11, '0');
        documentId = documentId.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      }

      return documentId;
    });
    Vue.filter('BRPrintDocumentPJFilter', (documentId) => {
      if (documentId !== undefined) {
        documentId = typeof documentId !== 'string' ? documentId.toString().replace(/[^a-zA-Z ]/g, '') : documentId;
        documentId = documentId.padStart(14, '0');
        documentId = documentId.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
      }

      return documentId;
    });
  },
};

export default BRPrintDocumentFilter;
